import httpClient from 'api/httpClient';
import {
  GeneralSuggestedAction,
  GeneralSuggestedActionType,
  GeneralSuggestionAction,
  GeneralSuggestionName,
} from 'models/SuggestedActions';

function getGeneralSuggestedActions() {
  return httpClient.get<GeneralSuggestedAction[]>(
    'users/suggested-actions/general',
  );
}

function muteGeneralSuggestedAction(
  actionType: GeneralSuggestedActionType,
  duration?: number,
) {
  return httpClient.post(
    `users/suggested-actions/${actionType}/mute`,
    { duration },
  );
}

function restoreGeneralSuggestedAction(actionType: GeneralSuggestedActionType) {
  return httpClient.post(`users/suggested-actions/${actionType}/restore`);
}

function actionedGeneralSuggestedAction(
  actionType: GeneralSuggestedActionType,
  data: {
    suggestionName: GeneralSuggestionName;
    suggestionAction: GeneralSuggestionAction;
  },
) {
  return httpClient.post(
    `users/suggested-actions/${actionType}/action`,
    data,
  );
}

export default {
  getGeneralSuggestedActions,
  muteGeneralSuggestedAction,
  restoreGeneralSuggestedAction,
  actionedGeneralSuggestedAction,
};
